import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { EXPERIMENT_SETTINGS_QC_START } from 'redux/actionTypes/experimentSettings';
import loadBackendStatus from 'redux/actions/backendStatus/loadBackendStatus';
var runGem2s = function runGem2s(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/gem2s"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 3:
            dispatch({
              type: EXPERIMENT_SETTINGS_QC_START,
              payload: {}
            });
            _context.next = 6;
            return dispatch(loadBackendStatus(experimentId));
          case 6:
            return _context.abrupt("return", true);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_STARTING_PIPLELINE);
            if (!(errorMessage !== endUserMessages.ERROR_NO_PERMISSIONS)) {
              _context.next = 15;
              break;
            }
            _context.next = 15;
            return dispatch(loadBackendStatus(experimentId));
          case 15:
            return _context.abrupt("return", false);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default runGem2s;